import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../i18n/index.js";

// Drop-in replacement for the old window.go(route, anchor) helper.
// Builds locale-prefixed paths and handles in-page anchors.
export function useLocaleNav() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const locale = SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;

  return useCallback(
    (route, anchor) => {
      const path = route === "home" ? `/${locale}` : `/${locale}/${route}`;
      navigate(path);
      if (anchor) {
        setTimeout(() => {
          document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 60);
      }
    },
    [navigate, locale]
  );
}

export function useCurrentLocale() {
  const { lang } = useParams();
  return SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
}
